export default "__VITE_ASSET__D_JeCyRo__"